import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    partnerPhoneNumber?: string;
}

const NoActivePlan: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    return (
        <React.Fragment>
            <div className="box">
                <div className="box-header col-xs-12 col-sm-12" style={{ backgroundColor: "#F4F4F4" }}>
                    <div className="content-sub-title text-align-center">
                        <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                            <em className="las la-exclamation-circle "></em>
                        </div>
                    </div>
                </div>
                <div className="box-content text-align-center">
                    <div className="msg-generic">{tLang("manageAccount.protectionPlan.noActivePlan.youCurrentlyHave")}</div>
                    <div className="msg-generic">{tLang("manageAccount.protectionPlan.noActivePlan.pleaseContactUs")}</div>
                    <div className="msg-generic">
                        {tLang("manageAccount.protectionPlan.noActivePlan.withRegardToYourAccount")}{" "}
                        <a href={`tel:'${props.partnerPhoneNumber}'`}>{props.partnerPhoneNumber}</a>
                        <div className="space-divider margin-top-l" />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default NoActivePlan;
